import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

export default createStore( {
    state: {
        rentalDeviceIndex: null,
        orderSuccess: null,
        dotPay: null,
        traditionalTransfer: null,
        orderId: null,
        orderAmount: null,
        orderContinuation: null,
        dotPayPaymentCounter: 0,
        dotPayPaymentLink: null,
        nextDeviceTrigger: null,
    },

    mutations: {
        SetRentalDeviceIndex(state, value) {
            state.rentalDeviceIndex = value;
        },

        SetOrderSuccess(state, value) {
          state.orderSuccess = value
        },

        SetDotPay(state, value) {
            state.dotPay = value
        },

        SetTraditionalTransfer(state, value) {
            state.traditionalTransfer = value
        },

        SetOrderId(state, value) {
            state.orderId = value;
        },

        SetOrderAmount(state, value) {
            state.orderAmount = value;
        },

        SetOrderContinuation(state, value) {
            state.orderContinuation = value;
        },

        SetDotPayPaymentCounter(state, value) {
            state.dotPayPaymentCounter += value;
        },

        ResetDotPayPaymentCounter(state) {
            state.dotPayPaymentCounter = 0;
        },

        SetDotPayPaymentLink(state, value) {
            state.dotPayPaymentLink = value
        },

        SetNextDeviceTrigger(state, value) {
            state.nextDeviceTrigger = value
        }
   },

   plugins: [createPersistedState()]
});